var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "px-4 py-5 border-b border-gray-200 sm:px-6 items-center grid grid-cols-3",
    },
    [
      _c("div", { staticClass: "col-span-2 flex items-center space-x-2" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.avatar,
                expression: "avatar",
              },
            ],
            staticClass: "mr-2",
          },
          [
            _vm.image
              ? [
                  _c("s3-image", {
                    staticClass:
                      "inline-block h-10 w-10 rounded-full object-cover object-center",
                    attrs: { s3FileKey: _vm.image },
                  }),
                ]
              : [
                  _c(
                    "span",
                    {
                      staticClass:
                        "inline-flex items-center justify-center h-10 w-10 rounded-full",
                      style: `background-color: ${_vm.initialColor()}`,
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-lg font-medium leading-none text-white",
                        },
                        [_vm._v(_vm._s(_vm.initial))]
                      ),
                    ]
                  ),
                ],
          ],
          2
        ),
        _c("div", { staticClass: "truncate py-1" }, [
          _c(
            "h3",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.title,
                  expression: "title",
                },
              ],
              staticClass:
                "lg:text-lg text-base leading-4 font-medium text-gray-900",
            },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          ),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.subtitle,
                  expression: "subtitle",
                },
              ],
              staticClass:
                "mt-1 max-w-2xl sm:text-xs text-sm leading-4 text-gray-500 truncate",
            },
            [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
          ),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.badge,
              expression: "badge",
            },
          ],
          staticClass: "ml-auto flex flex-col",
        },
        [_c("badge", { attrs: { text: _vm.badge, color: _vm.color } })],
        1
      ),
      _vm._t("actions"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }